import React from 'react';

import { beaconComponentRegistryEntry, getUserAccountSettingsURL } from '~src/beacon/BeaconComponentRegistryFunctions';
import { DeepLink } from '~src/beacon/deepLink/DeepLink';

import { Messages } from '../../codegen/Localize';
import { IServerUserInfo } from '../../userManagement/users/models/IServerUserInfo';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { UserSettingsHelper } from '../UserSettingsHelper';
import { LanguageForm, LanguageFormFields,LanguageFormProps } from './LanguageForm';
import { LocaleForm, LocaleFormFields,LocaleFormProps } from './LocaleForm';
import { TimeZoneForm, TimeZoneFormFields, TimeZoneFormProps } from './TimeZoneForm';

const DEEPLINK_ID_REGION = 'locale';
const DEEPLINK_ID_LANGUAGE = 'language';
const DEEPLINK_ID_TIME_ZONE = 'time-zone';

export interface LanguageAndRegionSettingsProps {
  //data
  languageInitialValues: LanguageFormFields;
  localeInitialValues: LocaleFormFields;
  timeZoneInitialValues: TimeZoneFormFields;
  //meta data realted to business logic
  serverUser: IServerUserInfo;
  isServerUserSubplace?: boolean;
}

export function LanguageAndRegionSettings({languageInitialValues, localeInitialValues, timeZoneInitialValues, ...passThroughProps}: LanguageAndRegionSettingsProps) {
  const languageProps: LanguageFormProps = {
    initialValues: languageInitialValues,
    serverUser: passThroughProps.serverUser
  };
  const localeProps: LocaleFormProps = {
    initialValues: localeInitialValues,
    serverUser: passThroughProps.serverUser
  };
  const timeZoneProps: TimeZoneFormProps = {
    initialValues: timeZoneInitialValues,
    serverUser: passThroughProps.serverUser
  };
  return (
    <>
    <h2 className={UserSettingsStyle.titleText}>{Messages.userSettings_LanguageAndRegion_Header()}</h2>
    <table>
      <tbody>
        <tr>
          <td className={UserSettingsStyle.tbody} colSpan={3}>
            <DeepLink deepLinkId={DEEPLINK_ID_LANGUAGE}>
              <LanguageForm {...languageProps}/>
            </DeepLink>
            <DeepLink deepLinkId={DEEPLINK_ID_REGION}>
              <LocaleForm {...localeProps}/>
            </DeepLink>
          </td>
        </tr>
        {!passThroughProps.isServerUserSubplace && UserSettingsHelper.getSectionDividerLine()}
        {!passThroughProps.isServerUserSubplace &&
        <tr>
          <td className={UserSettingsStyle.tbody} colSpan={3}>
            <DeepLink deepLinkId={DEEPLINK_ID_TIME_ZONE}>
              <TimeZoneForm {...timeZoneProps} />
            </DeepLink>
          </td>
        </tr>}
      </tbody>
    </table>
    </>
  );
}

export const RegionSettingBeaconConfig = beaconComponentRegistryEntry({
  command: () =>  Messages.locale(),
  deeplinkId: DEEPLINK_ID_REGION,
  url: (props) => getUserAccountSettingsURL(props.sessionInfo),
  isAdmin: false,
  tags: () => { return [Messages.userSettings_LanguageAndRegion_Header()]; }
});

export const LanguageSettingBeaconConfig = beaconComponentRegistryEntry({
  command: () =>  Messages.language(),
  deeplinkId: DEEPLINK_ID_LANGUAGE,
  url: (props) => getUserAccountSettingsURL(props.sessionInfo),
  isAdmin: false,
  tags: () => { return [Messages.userSettings_LanguageAndRegion_Header()]; }
});

export const TimeZoneSettingBeaconConfig = beaconComponentRegistryEntry({
  command: () =>  Messages.userSettings_TimeZoneSetting_Header(),
  deeplinkId: DEEPLINK_ID_TIME_ZONE,
  url: (props) => getUserAccountSettingsURL(props.sessionInfo),
  isAdmin: false,
  tags: () => { return [Messages.timeZoneHint(), Messages.userSettings_LanguageAndRegion_Header()]; }
});